import { SearchResultItem } from '../types';
import { isGuideResult, isNewsResult, isPostResult } from './type-guards';

/**
 * Gets the appropriate image URL from a search result based on its type
 */
export function getImageUrl(hit: SearchResultItem): string | undefined {
   if (isNewsResult(hit)) {
      const firstImageObj = Object.entries(hit.images)[0];
      return firstImageObj?.[1]?.url;
   } else if (isGuideResult(hit)) {
      return hit.image_url || hit.image;
   } else if (isPostResult(hit)) {
      return hit.author.avatar_url;
   } else {
      return hit.image_url || hit.image;
   }
}

/**
 * Gets the appropriate image URL from a search result based on its type
 */
export function getImageSubtext(hit: SearchResultItem): string | undefined {
   if (isPostResult(hit)) {
      return hit.author.username;
   }
}

/**
 * Gets the appropriate title from a search result based on its type
 */
export function getTitle(hit: SearchResultItem): string {
   return isNewsResult(hit) ? hit.post_title || '' : hit.title || '';
}
